import { render, staticRenderFns } from "./ElSavitarnaAction.vue?vue&type=template&id=20786a49&scoped=true&"
import script from "./ElSavitarnaAction.vue?vue&type=script&lang=js&"
export * from "./ElSavitarnaAction.vue?vue&type=script&lang=js&"
import style0 from "./ElSavitarnaAction.vue?vue&type=style&index=0&id=20786a49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20786a49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
